import React, { useEffect, useState } from 'react'
import backgroundImage from "../../assets/images/Breadcrumb.jpg"

const Breadcrumbs = ({ title, description, blogs, date, added, category, comment , image}) => {

    const [background,setbackground] = useState(backgroundImage);

    useEffect(() => {
        if(image){
            setbackground(image)
        }else{
            setbackground(backgroundImage)
        }
    },[image])

    // console.log(background);

    return (
        <div>
            {blogs ? (
                <div className="rs-breadcrumbs img5">
                    <div className="container">
                        <div className="breadcrumbs-inner">
                            <h1 className="page-title title-center text-center col-md-6 margin-auto">
                                {title}
                            </h1>
                            <ul className="single-posts-meta text-start text-xl-center ms-4 ms-xl-0 mt-2">
                                <li className='pe-4'>
                                    <span>
                                        <i className="bi bi-calendar-event fs-6"></i>
                                        {date}
                                    </span>
                                </li><li>
                                    <span>
                                        <i className="bi bi-person fs-5"></i>{added}
                                    </span>
                                </li>
                                <li className="post-cate md-w-75 text-start mt-2 mt-xl-0">
                                    <i className="bi bi-book fs-6"></i>
                                    <a href="#">{category}</a>
                                </li>
                                <li className="post-comment">
                                    <i className="bi bi-chat-dots fs-6 pe-1"></i>{comment}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="rs-breadcrumbs"
                style={{
                    backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url('${background}')`
                  }}
                >
                    <div className="container">
                        <div className="breadcrumbs-inner">
                            <h1 className="page-title">
                                {title}
                            </h1>
                            <div className="description">
                                <p className='col-md-7' dangerouslySetInnerHTML={{ __html: description }}></p>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    )
}

export default Breadcrumbs
